var base = require('settings/subscription/cancel-subscription');

Vue.component('spark-cancel-subscription', {
    mixins: [base],

    data() {
    	return {
    		cancelDialogVisible: false
    	}
    },

    created() {
		Bus.$on('updateUser', this.closeCancelDialog);
		Bus.$on('updateTeam', this.closeCancelDialog);
    },

    methods: {
        /**
         * Confirm the cancellation operation.
         */
        confirmCancellation() {
            this.cancelDialogVisible = true;
        },

        closeCancelDialog() {
        	this.cancelDialogVisible = false;
        }
    },


});
